module.exports = __webpack_public_path__ + "img/haishenwei.1c03e97d.png";